import { LoggingConfig, LogiSDKConfig } from '../model/config';
import { getSDKConfig } from './getSDKConfig';

type LogObject = Record<string, unknown>;

class Logger {
  private static instance: Logger;
  private enableLogger: boolean | undefined;
  private transmit?: LoggingConfig['transmit'];
  private logLevels = ['debug', 'info', 'warn', 'error'];

  private constructor() {
    this.loadConfig();
  }

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private loadConfig() {
    const sdkConfig: LogiSDKConfig = getSDKConfig();
    if (sdkConfig?.logging) {
      this.enableLogger = sdkConfig.logging.enableLogger || false;
      this.transmit = sdkConfig.logging.transmit;
    }
  }

  private transmitLog(level: string, logEvent: LogObject) {
    if (
      this.enableLogger &&
      this.transmit?.send &&
      this.shouldLogLevel(level)
    ) {
      this.transmit.send(level, logEvent);
    }
  }

  private shouldLogLevel(currentLevel: string): boolean {
    if (!this.transmit?.level) {
      return true;
    }

    const levelHierarchy: Record<string, number> = {
      debug: 0,
      info: 1,
      warn: 2,
      error: 3,
    };

    const currentLevelValue = levelHierarchy[currentLevel.toLowerCase()] ?? 0;
    const transmitLevelValue =
      levelHierarchy[this.transmit.level.toLowerCase()] ?? 0;

    return currentLevelValue >= transmitLevelValue;
  }

  public error(message: string, errorObj?: LogObject | LogObject[]) {
    // console.error(`[ERROR] ${message}`, errorObj || '');
    this.transmitLog('error', {
      message,
      error: errorObj,
      timestamp: Date.now(),
    });
  }

  public warn(message: string, data?: LogObject) {
    this.transmitLog('warn', { message, data, timestamp: Date.now() });
  }

  public info(message: string, data?: LogObject) {
    this.transmitLog('info', { message, data, timestamp: Date.now() });
  }

  public debug(message: string, data?: LogObject) {
    this.transmitLog('debug', { message, data, timestamp: Date.now() });
  }

  public updateConfig() {
    this.loadConfig();
  }
}

export default Logger.getInstance();
